var _class, _descriptor, _descriptor2, _DTooltip;
function _initializerDefineProperty(target, property, descriptor, context) {
  if (!descriptor) return;
  Object.defineProperty(target, property, {
    enumerable: descriptor.enumerable,
    configurable: descriptor.configurable,
    writable: descriptor.writable,
    value: descriptor.initializer ? descriptor.initializer.call(context) : void 0
  });
}
function _defineProperty(obj, key, value) {
  key = _toPropertyKey(key);
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == typeof i ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != typeof t || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != typeof i) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
  var desc = {};
  Object.keys(descriptor).forEach(function (key) {
    desc[key] = descriptor[key];
  });
  desc.enumerable = !!desc.enumerable;
  desc.configurable = !!desc.configurable;
  if ('value' in desc || desc.initializer) {
    desc.writable = true;
  }
  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
    return decorator(target, property, desc) || desc;
  }, desc);
  if (context && desc.initializer !== void 0) {
    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
    desc.initializer = undefined;
  }
  if (desc.initializer === void 0) {
    Object.defineProperty(target, property, desc);
    desc = null;
  }
  return desc;
}
function _initializerWarningHelper(descriptor, context) {
  throw new Error('Decorating class property failed. Please ensure that ' + 'transform-class-properties is enabled and runs after the decorators transform.');
}
import Component from "@glimmer/component";
import { getOwner } from "@ember/application";
import { concat } from "@ember/helper";
import { service } from "@ember/service";
import { modifier } from "ember-modifier";
import { and } from "truth-helpers";
import concatClass from "discourse/helpers/concat-class";
import icon from "discourse-common/helpers/d-icon";
import DFloatBody from "float-kit/components/d-float-body";
import { TOOLTIP } from "float-kit/lib/constants";
import DTooltipInstance from "float-kit/lib/d-tooltip-instance";
import { setComponentTemplate } from "@ember/component";
import { createTemplateFactory } from "@ember/template-factory";
let DTooltip = (_class = (_DTooltip = class DTooltip extends Component {
  constructor() {
    super(...arguments);
    _initializerDefineProperty(this, "tooltip", _descriptor, this);
    _initializerDefineProperty(this, "internalTooltip", _descriptor2, this);
    _defineProperty(this, "tooltipInstance", new DTooltipInstance(getOwner(this), {
      ...this.allowedProperties,
      autoUpdate: true,
      listeners: true
    }));
    _defineProperty(this, "registerTrigger", modifier(element1 => {
      this.tooltipInstance.trigger = element1;
      this.options.onRegisterApi?.(this.tooltipInstance);
    }));
  }
  get options() {
    return this.tooltipInstance?.options;
  }
  get componentArgs() {
    return {
      close: this.tooltip.close,
      data: this.options.data
    };
  }
  get allowedProperties() {
    const properties1 = {};
    for (const [key1, value1] of Object.entries(TOOLTIP.options)) {
      properties1[key1] = this.args[key1] ?? value1;
    }
    return properties1;
  }
}, setComponentTemplate(createTemplateFactory(
/*
  
    <span
      {{this.registerTrigger this.allowedProperties}}
      class={{concatClass
        "fk-d-tooltip__trigger"
        (if this.tooltipInstance.expanded "-expanded")
      }}
      role="button"
      id={{this.tooltipInstance.id}}
      data-identifier={{this.options.identifier}}
      data-trigger
      aria-expanded={{if this.tooltipInstance.expanded "true" "false"}}
      ...attributes
    >
      <span class="fk-d-tooltip__trigger-container">
        {{#if (has-block "trigger")}}
          {{yield this.componentArgs to="trigger"}}
        {{else}}
          {{#if @icon}}
            <span class="fk-d-tooltip__icon">
              {{~icon @icon~}}
            </span>
          {{/if}}
          {{#if @label}}
            <span class="fk-d-tooltip__label">{{@label}}</span>
          {{/if}}
        {{/if}}
      </span>
    </span>

    {{#if this.tooltipInstance.expanded}}
      <DFloatBody
        @instance={{this.tooltipInstance}}
        @trapTab={{and this.options.interactive this.options.trapTab}}
        @mainClass={{concatClass
          "fk-d-tooltip__content"
          (concat this.options.identifier "-content")
        }}
        @innerClass="fk-d-tooltip__inner-content"
        @role="tooltip"
        @inline={{this.options.inline}}
      >
        {{#if (has-block)}}
          {{yield this.componentArgs}}
        {{else if (has-block "content")}}
          {{yield this.componentArgs to="content"}}
        {{else if this.options.component}}
          <this.options.component
            @data={{this.options.data}}
            @close={{this.tooltipInstance.close}}
          />
        {{else if this.options.content}}
          {{this.options.content}}
        {{/if}}
      </DFloatBody>
    {{/if}}
  
*/
{
  "id": "ltPEzvGn",
  "block": "[[[1,\"\\n    \"],[11,1],[16,0,[28,[32,0],[\"fk-d-tooltip__trigger\",[52,[30,0,[\"tooltipInstance\",\"expanded\"]],\"-expanded\"]],null]],[24,\"role\",\"button\"],[16,1,[30,0,[\"tooltipInstance\",\"id\"]]],[16,\"data-identifier\",[30,0,[\"options\",\"identifier\"]]],[24,\"data-trigger\",\"\"],[16,\"aria-expanded\",[52,[30,0,[\"tooltipInstance\",\"expanded\"]],\"true\",\"false\"]],[17,1],[4,[30,0,[\"registerTrigger\"]],[[30,0,[\"allowedProperties\"]]],null],[12],[1,\"\\n      \"],[10,1],[14,0,\"fk-d-tooltip__trigger-container\"],[12],[1,\"\\n\"],[41,[48,[30,4]],[[[1,\"          \"],[18,4,[[30,0,[\"componentArgs\"]]]],[1,\"\\n\"]],[]],[[[41,[30,2],[[[1,\"            \"],[10,1],[14,0,\"fk-d-tooltip__icon\"],[12],[1,[28,[32,1],[[30,2]],null]],[13],[1,\"\\n\"]],[]],null],[41,[30,3],[[[1,\"            \"],[10,1],[14,0,\"fk-d-tooltip__label\"],[12],[1,[30,3]],[13],[1,\"\\n\"]],[]],null]],[]]],[1,\"      \"],[13],[1,\"\\n    \"],[13],[1,\"\\n\\n\"],[41,[30,0,[\"tooltipInstance\",\"expanded\"]],[[[1,\"      \"],[8,[32,2],null,[[\"@instance\",\"@trapTab\",\"@mainClass\",\"@innerClass\",\"@role\",\"@inline\"],[[30,0,[\"tooltipInstance\"]],[28,[32,3],[[30,0,[\"options\",\"interactive\"]],[30,0,[\"options\",\"trapTab\"]]],null],[28,[32,0],[\"fk-d-tooltip__content\",[28,[32,4],[[30,0,[\"options\",\"identifier\"]],\"-content\"],null]],null],\"fk-d-tooltip__inner-content\",\"tooltip\",[30,0,[\"options\",\"inline\"]]]],[[\"default\"],[[[[1,\"\\n\"],[41,[48,[30,5]],[[[1,\"          \"],[18,5,[[30,0,[\"componentArgs\"]]]],[1,\"\\n\"]],[]],[[[41,[48,[30,6]],[[[1,\"          \"],[18,6,[[30,0,[\"componentArgs\"]]]],[1,\"\\n\"]],[]],[[[41,[30,0,[\"options\",\"component\"]],[[[1,\"          \"],[8,[30,0,[\"options\",\"component\"]],null,[[\"@data\",\"@close\"],[[30,0,[\"options\",\"data\"]],[30,0,[\"tooltipInstance\",\"close\"]]]],null],[1,\"\\n\"]],[]],[[[41,[30,0,[\"options\",\"content\"]],[[[1,\"          \"],[1,[30,0,[\"options\",\"content\"]]],[1,\"\\n        \"]],[]],null]],[]]]],[]]]],[]]],[1,\"      \"]],[]]]]],[1,\"\\n\"]],[]],null],[1,\"  \"]],[\"&attrs\",\"@icon\",\"@label\",\"&trigger\",\"&default\",\"&content\"],false,[\"if\",\"has-block\",\"yield\"]]",
  "moduleName": "/var/www/discourse/app/assets/javascripts/discourse/node_modules/.embroider/rewritten-packages/float-kit.d0433c99/node_modules/float-kit/components/d-tooltip.js",
  "scope": () => [concatClass, icon, DFloatBody, and, concat],
  "isStrictMode": true
}), _DTooltip), _DTooltip), (_descriptor = _applyDecoratedDescriptor(_class.prototype, "tooltip", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "internalTooltip", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
})), _class);
export { DTooltip as default };